import { gql } from 'react-apollo';

export const full = gql`
  fragment allFaqAnswersFields on FaqAnswer {
    id
    question
    answer
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/fragments/faqAnswer.js